var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      class: [
        "risk-maintenance-id-cell",
        {
          "risk-maintenance-id-cell__warning-label": _vm.showWarning,
        },
      ],
    },
    [
      _c(
        "span",
        {
          staticClass: "risk-maintenance-id-cell__ids",
        },
        [
          _vm._l(_vm.idLinks, function (item, index) {
            return _c(
              "span",
              {
                key: index,
              },
              [
                item.href
                  ? _c(
                      "a",
                      {
                        staticClass: "risk-maintenance-id-cell__link",
                        attrs: {
                          href: item.href,
                          rel: "noopener noreferrer",
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(item.id))]
                    )
                  : [_vm._v(_vm._s(item.id))],
                index < _vm.idLinks.length - 1
                  ? _c("span", [_vm._v(", ")])
                  : _vm._e(),
              ],
              2
            )
          }),
          _vm.idLinks.length === 0 ? [_vm._v("-")] : _vm._e(),
        ],
        2
      ),
      _vm.showWarning
        ? _c("pui-icon", {
            attrs: {
              id: `tooltip-target-risk-id-${_vm.rowId}`,
              "icon-color": "#fd7e14",
              "icon-name": "warning-circle",
            },
          })
        : _vm._e(),
      _vm.showWarning
        ? _c(
            "b-tooltip",
            {
              attrs: {
                target: `tooltip-target-risk-id-${_vm.rowId}`,
                "custom-class": "hover-table",
                triggers: "hover",
              },
            },
            [
              _vm._v(
                " Some of the fields in this budget request have different values in MSP/PT Risk. "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }